import React from "react";
import moment from "moment";
import CONSTANT from "./../../constant";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";

import Header from "../../component/common/Header";
import { getDateParts, getCookie } from "../../utils";
import {
  getFilesPendingWithEmployee,
  getFilesPendingWithEmployeeGlobalList,
} from "./../../actions/FileAction";
import Shimmer from "../../component/common/Shimmer";
import { PendingFiles } from "./../../component/file/FileTimeline";
import constant from "./../../constant";

class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    this.state = {
      page: 1,
      limit: 10,
      searchKeyword: "",
      total: 0,
      pending: undefined,
      list: undefined,
      userDetail,
      userOptions: undefined,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.allFiles;
    this.loadList();
    this.loadGlobalList();
  }

  render() {
    const { page, list, pending, userDetail, userOptions, limit, total } =
      this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card homedob p-4 mb-4">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Open File(s)</h1>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card-body">
                    {userOptions !== undefined && (
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                          <div className="stats-container">
                            <div className="stat-card">
                              <div className="circle-number">
                                {userOptions?.stats?.total_files}
                              </div>
                              <div className="stat-label">Open File(s)</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                          <div className="stats-container">
                            <div className="stat-card">
                              <div className="circle-number">
                                {userOptions?.stats?.total_files_hod}
                              </div>
                              <div className="stat-label">With HOD(s)</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                          <div className="stats-container">
                            <div className="stat-card">
                              <div className="circle-number">
                                {userOptions?.stats?.total_files_non_hod}
                              </div>
                              <div className="stat-label">With Others</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {userOptions === undefined && (
                    <div className="skeleton mb-3">
                      <div className="skeleton-wrapper">
                        <div className="skeleton-wrapper-inner">
                          <div className="skeleton-wrapper-body">
                            <div className="skeleton-avatar" />
                            <div className="skeleton-author" />
                            <div className="skeleton-label" />
                            <div className="skeleton-content-1" />
                            <div className="skeleton-content-2" />
                            <div className="skeleton-content-3" />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="card homedob p-4 mb-4">
              <div className="row">
                <div className="col-md-12">
                  <div className="searchboxopenfile">
                    <div className="row">
                      <div className="col-md-6">
                        <label>&nbsp;</label>
                        {userOptions != undefined ? (
                          <Typeahead
                            className="mb-2 h-10"
                            id="public-methods-example"
                            labelKey="name"
                            multiple={false}
                            options={this.state.userOptions.pendingUsers}
                            placeholder="Search by name"
                            onChange={(selected: any) => {
                              if (
                                Array.isArray(selected) &&
                                selected.length === 0
                              ) {
                                // When cleared, reset to original list
                                this.setState(
                                  {
                                    searchKeyword: "",
                                    page: 1,
                                  },
                                  () => {
                                    this.loadList();
                                  }
                                );
                              } else if (selected.length > 0) {
                                const searchKeyword =
                                  selected[0].name ||
                                  selected[0].value ||
                                  selected[0];
                                this.setState(
                                  {
                                    searchKeyword: searchKeyword,
                                    page: 1,
                                  },
                                  () => {
                                    this.loadList();
                                  }
                                );
                              }
                            }}
                          />
                        ) : (
                          " "
                        )}
                      </div>

                      {list !== undefined && (
                        <div className="col-md-6 text-right w-100">
                          <label>Select Range: </label>
                          <select
                            className="form-select p-2 px-4"
                            value={limit}
                            onChange={(e: any) =>
                              this.handleLimitChange(e.target.value)
                            }
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            <option value="50">50</option>
                          </select>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="list-container mb-4">
                    <div className="table-container">
                      <div className="table-wrapper radius-4">
                        <table className="tablen">
                          <thead>
                            <tr>
                              <th>Comp. No.</th>
                              <th scope="col" className="text-nowrap">
                                Initiated By
                              </th>
                              <th scope="col">Subject</th>
                              <th scope="col" className="text-nowrap">
                                File Number
                              </th>
                              {/* <th scope="col" className="text-nowrap">
                                Financial Implication
                              </th> */}
                              <th scope="col" className="text-nowrap">
                                Created on
                              </th>
                              <th scope="col" className="text-nowrap">
                                Modified on
                              </th>
                              <th scope="col" className="text-nowrap">
                                Pending(Days)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {list === undefined && (
                              <tr>
                                <td colSpan={8} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}
                            {list !== undefined && list.length === 0 && (
                              <tr>
                                <td colSpan={8} className="text-center">
                                  No records found
                                </td>
                              </tr>
                            )}

                            {list !== undefined &&
                              list.map((item: any, index: number) => {
                                const detailPageURL =
                                  CONSTANT.component.userFileDetail.url.replace(
                                    ":code",
                                    item.code
                                  );
                                const dated = getDateParts(item.dated);
                                const mo = getDateParts(item.modifiedOn);
                                const subjectStr =
                                  item.subject.length > 50
                                    ? item.subject.substr(0, 50) + "..."
                                    : item.subject;
                                const sd = moment(item.modifiedOn);
                                const ed = moment();
                                const diff = Math.floor(
                                  moment.duration(ed.diff(sd)).asDays()
                                );
                                let diffCSSClassName = "";
                                if (diff >= 0 && diff <= 7) {
                                  diffCSSClassName = "text-primary";
                                } else if (diff > 7 && diff <= 14) {
                                  diffCSSClassName = "text-info";
                                } else if (diff > 14 && diff <= 21) {
                                  diffCSSClassName = "text-warning";
                                } else {
                                  diffCSSClassName = "text-danger";
                                }
                                return (
                                  <tr
                                    key={index}
                                    className="c-pointer"
                                    onClick={() =>
                                      this.openDetailPage(detailPageURL)
                                    }
                                  >
                                    <td className="sno">
                                      {item.code}
                                    </td>
                                    <td className="subject">
                                      {item.pendingWithName}
                                      {item.isHOD ? <b>(HOD)</b> : null}
                                    </td>
                                    <td>{subjectStr}</td>
                                    <td>{item.fileNumber}</td>
                                    {/* <td className="financial">
                                      {item.financialImplication
                                        ? `${
                                            CONSTANT.static.currencySymbol
                                          } ${parseFloat(
                                            item.financialImplication
                                          ).toLocaleString(
                                            CONSTANT.static.locale
                                          )}`
                                        : "-"}
                                    </td> */}
                                    <td>
                                      <span className="status-badge created text-nowrap">{`${dated.date} ${dated.monthName} ${dated.year}`}</span>
                                    </td>
                                    <td>
                                      <span className="status-badge modified text-nowrap">{`${mo.date} ${mo.monthName} ${mo.year}`}</span>
                                    </td>
                                    <td
                                      className={`${diffCSSClassName} ${"text-center"}`}
                                    >
                                      <b>
                                        <span className="pending-days">
                                          {diff === 0 ? "Updated Today" : diff}
                                        </span>
                                      </b>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                        <div className="mt-4 p-4">
                          {list !== undefined && list.length !== 0 && (
                            <ResponsivePagination
                              activeItemClassName="Pagi-number-ac"
                              current={page}
                              maxWidth={1}
                              total={Math.ceil(total / limit)}
                              onPageChange={this.handlePageChange}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  loadList = (
    page: number = this.state.page,
    limit: number = this.state.limit,
    searchKeyword: string = this.state.searchKeyword
  ) => {
    getFilesPendingWithEmployee(page, limit, searchKeyword).then((res: any) => {
      if (res && res.result && res.result.length > 0) {
        this.setState({
          list: res.result,
          total: res.result[0]["total"] || 0,
        });
      } else {
        this.setState({
          list: [],
          total: 0,
        });
      }
    });
  };

  loadGlobalList = () => {
    getFilesPendingWithEmployeeGlobalList().then((res: any) => {
      if (res) this.setState({ userOptions: res.result });
    });
  };

  handlePageChange = (newPage: number) => {
    this.setState({ page: newPage }, () => {
      this.loadList();
    });
  };

  handleLimitChange = (newLimit: number) => {
    this.setState({ limit: newLimit, page: 1 }, () => {
      this.loadList();
    });
  };

  openDetailPage = (url: string) => {
    this.props.history.push(url);
  };

  changePage = (e: any) => {
    const type = e.target.dataset.type;
    const page = type === "+" ? this.state.page + 1 : this.state.page - 1;
    this.setState({ page }, () => {
      this.loadList();
    });
  };
}

export default ComponentName;